// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.quill.quill-customized {
  width: 100%;
}
.quill.quill-customized.hideToolBar .ql-toolbar {
  display: none;
}
.quill.quill-customized.hideToolBar .ql-snow {
  border: none;
}
.quill.quill-customized.autoHeight .ql-editor {
  min-height: auto !important;
}
.quill.quill-customized .ql-toolbar {
  border-radius: 6px 6px 0 0;
  background-color: #f2f3f6;
  border-bottom: none;
}
.quill.quill-customized .ql-toolbar.ql-snow,
.quill.quill-customized .ql-container.ql-snow {
  border-color: var(--input);
}
.quill.quill-customized .ql-container {
  border-radius: 0 0 6px 6px;
}
.quill.quill-customized .ql-container .ql-editor {
  min-height: 250px;
}

.quill-customized ul li::before {
  color: #FCE000 !important;
  content: "●" !important;
}`, "",{"version":3,"sources":["webpack://./src/infoTrac/components/Common/QuillRichTextEditor/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;AAEF;AACI;EACE,aAAA;AACN;AAEI;EACE,YAAA;AAAN;AAKI;EACE,2BAAA;AAHN;AAOE;EACE,0BAAA;EACA,yBAAA;EACA,mBAAA;AALJ;AAUI;;EACE,0BAAA;AAPN;AAWE;EACE,0BAAA;AATJ;AAWI;EACE,iBAAA;AATN;;AAeE;EACE,yBAAA;EACA,uBAAA;AAZJ","sourcesContent":[".quill.quill-customized {\n  width: 100%;\n\n  &.hideToolBar {\n    .ql-toolbar {\n      display: none;\n    }\n\n    .ql-snow {\n      border: none;\n    }\n  }\n\n  &.autoHeight {\n    .ql-editor {\n      min-height: auto !important;\n    }\n  }\n\n  .ql-toolbar {\n    border-radius: 6px 6px 0 0;\n    background-color: #f2f3f6;\n    border-bottom: none;\n  }\n\n  .ql-toolbar,\n  .ql-container {\n    &.ql-snow {\n      border-color: var(--input);\n    }\n  }\n\n  .ql-container {\n    border-radius: 0 0 6px 6px;\n\n    .ql-editor {\n      min-height: 250px;\n    }\n  }\n}\n\n.quill-customized {\n  ul li::before {\n    color: #FCE000 !important;\n    content: '\\25CF' !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
